import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../css/CadastrarProdutos.css";
import ModalCategorias from "./ModalCategorias";
import { useProdutos } from "../context/ProdutosContext";
import BackButton from "../components/BackButton";
import { useLoading } from "../context/LoadingContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CadastrarProdutos = () => {
  const {
    categorias,
    listarCategorias,
    criarCategoria,
    criarProduto,
    adicionarImagemProduto,
    adicionarProdutoCategoria,
  } = useProdutos();
  const { id } = useParams();
  const { setIsLoading } = useLoading();

  const [etapa, setEtapa] = useState(1); // Controle da etapa
  const [produto, setProduto] = useState({
    categoria: "",
    nome: "",
    preco: "",
  });
  const [imagem, setImagem] = useState(null); // Estado para a imagem
  const [previewImagem, setPreviewImagem] = useState(null);
  const [produtoId, setProdutoId] = useState(null); // Guarda o ID do produto criado
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    listarCategorias(id, true);
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduto((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCategoria = async (novaCategoria) => {
    setIsLoading(true);
    const toastId = toast.loading("Adicionando categoria...");
    try {
      await criarCategoria(id, novaCategoria);
      toast.update(toastId, {
        render: "Categoria adicionada com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      setIsModalOpen(false);
      listarCategorias(id); // Atualiza a lista de categorias
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: "Erro ao adicionar categoria. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitProduto = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const toastId = toast.loading("Cadastrando produto...");
    try {
      // Cria o produto
      const responseProdutoId = await criarProduto(id, {
        nome: produto.nome,
        preco: parseFloat(produto.preco),
      });

      setProdutoId(responseProdutoId);

      // Associa o produto à categoria selecionada
      await adicionarProdutoCategoria(produto.categoria, responseProdutoId);

      toast.update(toastId, {
        render: "Produto cadastrado e associado à categoria com sucesso! Adicione a imagem agora.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setEtapa(3);
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: "Erro ao cadastrar produto ou associar à categoria. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImagem(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreviewImagem(previewUrl);
    }
  };

  const handleSubmitImagem = async (e) => {
    e.preventDefault();
    if (!imagem || !produtoId) return;

    setIsLoading(true);
    const toastId = toast.loading("Adicionando imagem...");
    try {
      await adicionarImagemProduto(id, produtoId, imagem);
      toast.update(toastId, {
        render: "Imagem adicionada com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      setImagem(null);
      setPreviewImagem(null);
      setEtapa(1); // Reinicia o formulário
      setProduto({ categoria: "", nome: "", preco: "" });
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: "Erro ao adicionar imagem. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="cadastrar-produtos-container">
      <ToastContainer />
      <BackButton inline />
      <form
        onSubmit={etapa === 2 ? handleSubmitProduto : handleSubmitImagem}
        className="produto-form"
      >
        <h2>Cadastrar Produtos</h2>

        {/* Etapa 1: Selecionar ou Criar Categoria */}
        {etapa === 1 && (
          <div className="form-group">
            <label>Categoria</label>
            <select
              name="categoria"
              value={produto.categoria}
              onChange={(e) => {
                if (e.target.value === "nova") {
                  setIsModalOpen(true);
                } else {
                  setProduto((prev) => ({
                    ...prev,
                    categoria: e.target.value,
                  }));
                  setEtapa(2);
                }
              }}
            >
              <option value="" disabled>
                Selecione uma categoria
              </option>
              {categorias.map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  {categoria.nome}
                </option>
              ))}
              <option value="nova">+ Adicionar Categoria</option>
            </select>
          </div>
        )}

        {/* Etapa 2: Preencher Dados do Produto */}
        {etapa === 2 && (
          <>
            <div className="form-group">
              <label>Nome do Produto</label>
              <input
                type="text"
                name="nome"
                value={produto.nome}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Preço</label>
              <input
                type="number"
                step="0.01"
                name="preco"
                value={produto.preco}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit">Salvar Produto</button>
          </>
        )}

        {/* Etapa 3: Adicionar Imagem */}
        {etapa === 3 && (
          <>
            <div className="form-group">
              <label>Imagem:</label>
              <input
                type="file"
                name="imagem"
                accept="image/*"
                onChange={handleImageUpload}
              />
            </div>
            {previewImagem && (
              <div className="image-preview">
                <h4>Pré-visualização da Imagem:</h4>
                <img src={previewImagem} alt="Pré-visualização" />
                <button
                  type="button"
                  onClick={() => {
                    setImagem(null);
                    setPreviewImagem(null);
                  }}
                >
                  Remover Imagem
                </button>
              </div>
            )}
            {/* Chamando diretamente handleSubmitImagem */}
            <button
              type="button" // Altere para type="button" para evitar submissão automática do form
              onClick={handleSubmitImagem} // Chama explicitamente a função
            >
              Salvar Imagem
            </button>
          </>
        )}
      </form>

      {/* Modal para adicionar categorias */}
      {isModalOpen && (
        <ModalCategorias
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onAddCategory={handleAddCategoria}
        />
      )}
    </div>
  );
};

export default CadastrarProdutos;
